import React, {useState} from 'react';
import {
  closestCenter,
  DndContext, 
  DragOverlay,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';

import { SortableItem } from './SortableItem';
import Item from './Item';
import './styles.scss';

const Edit = (props) => {
  const [activeId, setActiveId] = useState(null);
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  return (
      <div className="sortable">
        <DndContext 
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragStart={handleDragStart}
        onDragEnd={handleDragEnd}
        >
        <SortableContext 
            items={props.items}
            strategy={verticalListSortingStrategy}
        >
            {props.items.map(item => <SortableItem changeView={props.changeView} isCopying={props.isCopying} copy={props.copy} updateName={props.updateName} key={item.salesDistrictScenarioId} {...item} />)}
        </SortableContext>
        <DragOverlay>
            {activeId ? <Item id={activeId} {...props.items.find(item => item.id === activeId)} /> : null}
        </DragOverlay>
        </DndContext>
    </div>
  );
  
  function handleDragStart(event) {
    const {active} = event;
    setActiveId(active.id);
  }
  
  function handleDragEnd(event) {
    const {active, over} = event;

    if (active.id !== over.id) {
      props.setItems((items) => {
        const oldIndex = items.findIndex(item => item.id === active.id);
        const newIndex = items.findIndex(item => item.id === over.id);
        
        return arrayMove(items, oldIndex, newIndex);
      });
    }
    
    setActiveId(null);
  }
}

export default Edit;